import { AuthGuard } from "src/guards/auth-guard";
import KYB from "./KYB";

export default function KYBProtectedPage() {
  return (
    <AuthGuard>
      <KYB />
    </AuthGuard>
  );
}
